/**
 * Data Center - English (US)
 * 数据中心 - 美式英语
 */
export default {
  title: 'Data Center',
  regionData: 'Region Data',
  riskControlData: 'Risk Control Data',
  businessData: 'Business Data',
  reconciliationData: 'Reconciliation Data',
  agentVersion: 'Agent Inventory Data',
  agentVersionNew: 'Agent Stage Inventory Data',
  agencyActivation: 'Agent Activation Data',
  agencyActivationAgentId: 'Agent ID',
  agencyActivationAgentName: 'Agent name',
  agentOrdering: 'Agent Order Data',
  crossSubjectSupervisorQuota: 'Cross-Subject Supervisor Quota',
  crossSubjectSupervisorAudit: 'Cross-Subject Supervisor Audit',
  statsPeriod: 'Period',
  dealerOrg: 'Dealer Org',
  placeholderSelectDealer: 'Select dealer',
  dealerId: 'Dealer ID',
  dealerName: 'Dealer Name',
  belongArea: 'Area',
  starAgentArea: 'Province/City/District',
  sameSubjectDxStudentCount: 'Same-Subject Supervisor Students',
  sameSubjectExemptLimit: 'Same-Subject Exempt Limit',
  sameSubjectUsedLimit: 'Same-Subject Used Limit',
  currentDealerUsedLimit: 'Current Dealer Used Limit',
  sameSubjectUpperLimit: 'Same-Subject Upper Limit',
  adjustQuota: 'Adjust Quota',
  partner: 'Partner: ',
  sameSubjectDealers: 'Same-Subject Dealers: ',
  freeRatio: 'Exempt Ratio: ',
  limitRatio: 'Upper Limit Ratio: ',
  placeholderFreeRatio: 'Enter exempt ratio',
  placeholderLimitRatio: 'Enter upper limit ratio',
  pleaseEnterValidNumber: 'Enter a valid number',
  valueRangeZeroOne: 'Value must be between 0 and 1',
  maxTwoDecimals: 'At most 2 decimal places',
  limitRatioMustGtFree: 'Upper limit ratio must be greater than exempt ratio',
  adjustSuccess: 'Adjusted successfully',
  adjustFail: 'Adjust failed',
  adjustFailRetry: 'Adjust failed, please retry',

  // dealerRestrictionManagement
  viewRestrictDetail: 'View restriction detail',
  addRestriction: 'Add restriction',
  cancelRestriction: 'Cancel restriction',
  restrictRule: 'Restriction rule',
  placeholderSelectRestrictRule: 'Select restriction rule',
  restrictRuleName: 'Restriction rule name',
  restrictScope: 'Restriction scope',
  placeholderSelectRestrictScope: 'Select restriction scope',
  restrictReason: 'Restriction reason',
  cancelRestrictReason: 'Cancel restriction reason',
  placeholderRestrictReason: 'Enter restriction reason',
  restrictReasonMinLength: 'Restriction reason at least 5 characters',
  addRestrictSuccess: 'Restriction added',
  cancelRestrictSuccess: 'Restriction cancelled',
  dealerLocation: 'Location',
  restrictStatus: 'Restriction status',
  placeholderRestrictStatus: 'Select status',
  statusUnrestricted: 'Unrestricted',
  statusRestricted: 'Restricted',
  schoolName: 'Dealer name',

  // quotaManagement
  increaseQuota: 'Increase purchasable quota',
  decreaseQuota: 'Decrease purchasable quota',
  increaseAction: 'Increase',
  decreaseAction: 'Decrease',
  purchasableQuota: 'Purchasable quota',
  dealerIdColon: 'Dealer ID: ',
  dealerNameColon: 'Dealer name: ',
  remainQuotaColon: 'Remaining quota: ',
  changeQuotaColon: 'Quota: ',
  reasonColon: 'Reason: ',
  placeholderNumber: 'Enter number',
  placeholderReasonRange: 'Enter reason (5-100 chars)',
  placeholderReason: 'Enter reason',
  reasonLengthRule: 'Reason must be 5-100 characters',
  totalLimit: 'Total purchasable quota',
  buyLimit: 'Purchased quota',
  remainLimit: 'Remaining quota',
  usedLimit: 'Used quota',
  areaLabel: 'Area',

  // Subscription (BusinessData)
  consumeNo: 'Consume serial no.',
  placeholderConsumeNo: 'Enter consume serial no.',
  cardNo: 'Card no.',
  placeholderCardNo: 'Enter card no.',
  useDate: 'Use date',
  rangeTo: ' to ',
  learningMachineAccount: 'Learning machine account',
  placeholderLearningMachineAccount: 'Enter account',
  cardAgent: 'Card agent',
  placeholderCardAgent: 'Select card agent',
  machineAgent: 'Machine agent',
  placeholderMachineAgent: 'Select machine agent',
  useTime: 'Use time',
  useOperator: 'Operator',
  renewArea: 'Renew area',
  renewLevel: 'Renew level',
  renewMonths: 'Renew months',
  cardType: 'Card type',
  cardAgentId: 'Card agent ID',
  cardAgentName: 'Card agent name',
  machineAgentId: 'Machine agent ID',
  machineAgentName: 'Machine agent name',
  exportSubscriptionConsume: 'Subscription consume export',

  // transformedData
  statsPeriodLabel: 'Period',
  placeholderStatsPeriod: 'Select period',
  placeholderSelect: 'Select',
  selectTimeRange: 'Select time range',
  dealerLocationArea: 'Dealer location',
  buyLimitCount: 'Purchase quota',
  openAccountNum: 'Opened accounts',
  oneTransformNum: 'Current month conversion',
  oneTransformRate: 'Current month conversion rate',
  twoTransformNum: 'Next month conversion',
  twoTransformRate: 'Next month conversion rate',
  threeTransformNum: 'Three months conversion',
  threeTransformRate: 'Three months conversion rate',
  totalTransformNum: 'Total conversion',
  totalTransformRate: 'Total conversion rate',

  // leagueMatchManage
  leagueSelect: 'League',
  placeholderLeague: 'Select league',
  zoneSelect: 'Zone',
  placeholderZone: 'Select zone',
  dealerQuery: 'Dealer query',
  placeholderDealerIdOrName: 'Dealer ID or name',
  queryByQuarter: 'By quarter',
  placeholderQuarter: 'Select quarter',
  queryByMonth: 'By month',
  placeholderMonth: 'Select month',
  clearFilter: 'Clear filter',
  pleaseSelectLeague: 'Select league',
  pleaseSelectZone: 'Select zone',
  pleaseSelectQuarter: 'Select quarter',
  pleaseSelectMonth: 'Select month',
  allStarMatch: 'All-Star',
  superLeague: 'Super League',
  firstDivision: 'First Division',
  allStarZone: 'All-Star Zone',
  east: 'East',
  west: 'West',
  south: 'South',
  north: 'North',
  areaProvinceCity: 'Province/City',
  matchName: 'Match',
  leagueRank: 'Match rank',
  growthValue: 'Growth value',
  growthChange: 'Growth change',
  rankChange: 'Rank change',
  quarterFormat: 'Quarter',

  // promotionDashboard
  exportDetail: 'Export detail',
  totalCountLabel: 'Total units: ',
  operationRemind: 'Notice',
  exportConfirmText: 'Export will use current filters. Continue?',
  statsPeriodColon: 'Period: ',
  regionFilter: 'Region',
  placeholderRegion: 'Select region',
  orgInfo: 'Organization',
  placeholderOrg: 'Select organization',
  promoterQuery: 'Promoter: ',
  placeholderPromoterName: 'Enter promoter name',
  salesPerson: 'Sales person',
  registerTime: 'Register time',
  promoteCount: 'Promote count',

  // ReconciliationData shared
  agent: 'Agent',
  placeholderAgent: 'Select agent',
  dispatchTime: 'Dispatch time',
  createTime: 'Create time',
  placeholderStatus: 'Select status',
  productType: 'Product type',
  placeholderProductType: 'Select product type',
  orderNoLabel: 'Order no.: ',
  deliverValuePlaceholderOrderNo: 'Enter purchase order no.',
  payStatusColon: 'Pay status:',
  orderStatusColon: 'Order status:',
  unpaid: 'Unpaid',
  partialPay: 'Partial',
  paid: 'Paid',
  agentId: 'Agent ID',
  agentName: 'Agent name',
  partnerIntroduceCustomerActivationAgentId: 'Agent ID',
  partnerIntroduceCustomerActivationAgentName: 'Agent name',
  province: 'Province',
  city: 'City',
  district: 'District',
  receiveAddress: 'Address',
  receiver: 'Receiver',
  createTimeLabel: 'Create time',
  equipmentValueAgentId: 'Agent ID',
  equipmentValueAgentName: 'Agent name',
  deliverValueAgentId: 'Agent ID',
  deliverValueAgentName: 'Agent name',
  deliverValueRemarkLabel: 'Remark',
  purchaseOrderNo: 'Order no.',
  productName: 'Product name',
  productNameCol: 'Product name',
  orderQty: 'Order qty',
  purchaseAmount: 'Purchase amount',
  isReturnPay: 'Return paid',
  orderStatus: 'Order status',
  transferQty: 'Transfer qty',
  cashAmountWithVoucher: 'Cash (incl. voucher)',
  voucherAmount: 'Voucher amount',
  prepayFreight: 'Prepay freight',
  dispatchAreaAgentId: 'Dispatch agent ID',
  dispatchAreaAgentName: 'Dispatch agent name',
  expressNo: 'Dispatch no.',
  // EquipmentValue
  machineStatusColon: 'Machine status:',
  inactive: 'Inactive',
  activated: 'Activated',
  subscribed: 'Subscribed',
  frozen: 'Frozen',
  productNameColon: 'Product name: ',
  placeholderProductName: 'Enter product name',
  snCode: 'SN',
  dispatchMonth: 'Dispatch month',
  expressCompany: 'Express',
  warehouse: 'Warehouse',
  expressNoLabel: 'Express no.',
  softActivateStatus: 'Soft activate status',
  hardActivateStatus: 'Hard activate status',
  hardActivateTime: 'Hard activate time',
  latestOrderNo: 'Latest order no.',
  freight: 'Freight',
  voucherPrice: 'Voucher price',
  cashPrice: 'Cash price',
  priceTotal: 'Price total',
  softActivateTime: 'Soft activate time',
  softActivateMonth: 'Soft activate month',
  firstDispatchTime: 'First dispatch time',
  // PurchaseValue
  purchaseValueAgentId: 'Agent ID',
  purchaseValueAgentName: 'Agent name',
  purchaseOrderNoShort: 'Order no.',
  purchaseValueDispatchType: 'Dispatch type',
  dispatchType: 'Dispatch type',
  payStatus: 'Pay status',
  orderCreateTime: 'Order create time',
  purchaseProductName: 'Product name',
  isDoubleOrder: 'Double order',
  purchaseQty: 'Purchase qty',
  dispatchNum: 'Dispatch qty',
  purchaseUnitPrice: 'Unit price',
  purchaseTotalAmount: 'Total amount',
  paidCashAmount: 'Paid cash',
  paidVoucherAmount: 'Paid voucher',
  // 激活率 ActivationRate
  regionCampusId: 'Parent Agent ID',
  regionCampusName: 'Parent Agent Name',
  activationRateUpperAgentId: 'Parent Agent ID',
  activationRateUpperAgentName: 'Parent Agent Name',
  statPeriod: 'Period',
  activeNum: 'Activated Count',
  activeOdds: 'Off-site Activation Rate',
  offsiteProviceNum: 'Off-province Count',
  offsiteCityNum: 'Off-city Count',
  offsiteDisNum: 'Off-district Count',
  rangeSeparatorTo: ' to ',
  // 仓库库存 Inventory
  timeLabel: 'Time',
  placeholderWarehouse: 'Select warehouse',
  // 采集明细 CollectDetails
  dateLabel: 'Date',
  studentLabel: 'Student: ',
  placeholderStudentName: 'Enter student name/account',
  accountTypeLabel: 'Account type: ',
  placeholderAccountType: 'Select account type',
  serviceCenterLabel: 'Service center: ',
  placeholderCampusId: 'Enter dealer ID',
  studentNameCol: 'Student Name',
  accountCol: 'Account',
  phoneCol: 'Phone',
  accountTypeCol: 'Account Type',
  serviceCenterId: 'Service Center ID',
  serviceCenterName: 'Service Center Name',
  deviceSn: 'Device SN',
  faceBasePhoto: 'Face Base Photo',
  photoCol: 'Photo',
  collectionTime: 'Collection Time',
  collectionMethod: 'Collection Method',
  livingDetectionMethod: 'Living Detection',
  livingScore: 'Living Score',
  isRecognize: 'Recognized',
  faceNum: 'Face Count',
  recognitionSimilarity: 'Recognition Similarity',
  recognitionResult: 'Recognition Result',
  face1Age: 'Face1 Age',
  face1SimilarFaceInfo: 'Face1 Similar Info',
  face2Age: 'Face2 Age',
  face2SimilarFaceInfo: 'Face2 Similar Info',
  employeeAccount: 'Employee',
  traineeAccount: 'Trainee',
  experienceAccount: 'Experience',
  prototypeAccount: 'Prototype',
  rangeSeparatorTilde: '~',
  // 私下率 PrivateRate
  privateOdds: 'Private Rate',
  privateNum: 'Private Count',
  // 激活地 ActivationLocation
  statsPeriodColon: 'Period:',
  placeholderStatsPeriodMonth: 'Select period (month)',
  activeLocationLabel: 'Active location:',
  placeholderActiveLocation: 'Select active location',
  queryBtn: 'Query',
  exportAllRegionData: 'Export all region data',
  pleaseSelectStatsPeriod: 'Please select period',
  pleaseSelectActiveLocation: 'Please select active location',
  learningMachineSn: 'Device SN',
  authArea: 'Auth area',
  campusLocation: 'Dealer location',
  parentAgentId: 'Parent agent ID',
  parentAgentName: 'Parent agent name',
  activeStatPeriod: 'Active period',
  activeLocationCol: 'Active location',
  isDifferentLocation: 'Off-site',
  activeDays: 'Active days in period',
  lastActiveAddress: 'Last active address',
  longitude: 'Longitude',
  latitude: 'Latitude',
  pleaseFillRequired: 'Please fill in required fields.',
  networkError: 'Network error',
  // 激活簇 ActivationCluster
  startDatePlaceholder: 'Start date',
  endDatePlaceholder: 'End date',
  thisAddressActiveSn: 'SN at this address',
  activeAddress: 'Active address',
  provinceCityDistrict: 'Province/City/District',
  lonAndLat: 'Longitude/Latitude',
  statisticalCycle: 'Period',
  thisAddressActiveNum: 'Active count at address',
  standardDeviation: 'Dispersion',
  campusNum: 'Campus count',
  campusIdString: 'Campus IDs',
  campusNameString: 'Campus names',
  nearestCampusId: 'Nearest store ID',
  nearestCampusName: 'Nearest store name',
  campusToActiveDistance: 'Distance to active',
  openTime: 'Open time',
  campusAgentId: 'Store agent ID',
  campusAgentName: 'Store agent name',
  isSameAgent: 'Same agent',
  campusProvinceCityDistrict: 'Store location',
  campusAddress: 'Store address',
  campusLonAndLat: 'Store coordinates',
  // 异常占比 AbnormalProportion
  dealerIdColon: 'Dealer ID: ',
  placeholderEnterDealerId: 'Enter dealer ID',
  statisticTime: 'Period',
  errorStaffAccountNum: 'Error staff accounts',
  errorStudentAccountNum: 'Error student accounts',
  errorMachineAccountNum: 'Error machine accounts',
  // 异常明细 ExceptionDetails
  placeholderSelectMonth: 'Select month',
  collectNum: 'Collect count',
  recognitionNum: 'Recognition count',
  errorNum: 'Error count',
  errorRate: 'Error rate',
  errorDetail: 'Error detail',
  serviceCenterIdCol: 'Service center ID',
  // 串货率 CollusionRate
  fleeingGoodsOdds: 'Collusion rate',
  fleeingGoodsNum: 'Collusion count',
  // 学员实名率 StudentRealName
  studentTotal: 'Total students',
  realNameStudentTotal: 'Real-name students',
  realNameRate: 'Real-name rate',
  activeStudentTotal: 'Active students (month)',
  realNameActiveStudentTotal: 'Real-name active (month)',
  realNameActiveRate: 'Active real-name rate (month)',
  locationAddress: 'Location',
  // 下级经销商跨区域活跃设备 CrossRegActiveEquipment
  snCodeLabel: 'Device SN',
  placeholderSnCode: 'Enter device SN',
  dealerLabel: 'Dealer',
  placeholderDealerIdName: 'Enter dealer ID/name',
  statusLabel: 'Status',
  placeholderStatus: 'Select status',
  statusNormal: 'Normal',
  statusBuffer: 'Buffer',
  statusLocked: 'Locked',
  statusAppeal: 'Appeal pending',
  softwareActivationDateLabel: 'Software activation date',
  placeholderSoftwareActivationRange: 'Select software activation range',
  lockDateLabel: 'Lock date',
  placeholderLockDateRange: 'Select lock date range',
  deviceModel: 'Device model',
  softActivateTime: 'Software activation time',
  activeProvinceCity: 'Activation province/city',
  crossRegActiveDate: 'Cross-region active date',
  crossRegActiveProvinceCity: 'Cross-region active location',
  dataSourceNameCol: 'Data source',
  handleTypeName: 'Status',
  handleTime: 'Lock date',
  exportBtn: 'Export',
  // 二级经销商激活簇 SecActivationCluster
  transferServiceCenterIdLabel: 'Transfer service center ID: ',
  placeholderTransferServiceCenterId: 'Enter transfer service center ID',
  studentNameAccountLabel: 'Student name/account: ',
  placeholderStudentNameOrAccount: 'Enter student name or account',
  auditStatusLabel: 'Audit status: ',
  placeholderAuditStatus: 'Select audit status',
  pendingAudit: 'Pending',
  auditApproved: 'Approved',
  auditRejected: 'Rejected',
  crossEntityApplyDetail: 'Cross-entity supervision application detail',
  crossEntityAuditTitle: 'Audit cross-entity supervision application',
  crossEntityApplyTitle: 'Cross-entity supervision application',
  studentAccountLabel: 'Student account:',
  studentNameLabel: 'Student name:',
  deviceDealerIdLabel: 'Device dealer ID:',
  deviceDealerNameLabel: 'Device dealer name:',
  transferServiceCenterIdLabel: 'Transfer service center ID:',
  transferServiceCenterNameLabel: 'Transfer service center name:',
  descriptionLabel: 'Description:',
  evidenceFilesLabel: 'Evidence files:',
  auditResultLabel: 'Audit result:',
  placeholderSelectAuditResult: 'Select audit result',
  remarkLabel: 'Remark:',
  placeholderRemark: 'Enter remark',
  enterRemarkRequired: 'Please enter remark',
  rejectRemarkRequired: 'Remark required when rejected',
  remarkLengthRule: 'Remark: 2-100 characters',
  remarkMinLength: 'Remark must be at least 2 characters',
  remarkMaxLength: 'Remark must not exceed 100 characters',
  submitAudit: 'Submit audit',
  auditSubmitSuccess: 'Audit submitted successfully',
  submitFailed: 'Submit failed',
  submitFailedRetry: 'Submit failed, please try again later',
  preview: 'Preview',
  applySubmitTimeLabel: 'Apply time: ',
  placeholderTimeRange: 'Select time range',
  auditBtn: 'Audit',
  viewDetail: 'View detail',
  studentUserName: 'Student name',
  studentAccountUser: 'Student account',
  deviceDealerId: 'Device dealer ID',
  deviceDealerName: 'Device dealer name',
  transferServiceCenterIdCol: 'Transfer service center ID',
  transferServiceCenterName: 'Transfer service center name',
  applyStatusName: 'Apply status',
  applySubmitTimeCol: 'Apply time',
  applySubmitUser: 'Applicant',
  reviewTimeCol: 'Review time',
  reviewerCol: 'Reviewer',
  // 代理商进销存 AgentVersion  
  agentVersionTip: 'Query all agents in the region: historical purchase, activation and latest stock.',
  agentVersionAgentId: 'Agent ID',
  agentVersionAgentName: 'Agent name',
  regionCol: 'Region',
  purchaseQtyExcludeSample: 'Purchase qty (excl. sample)',
  activeQtyExcludeSample: 'Activation qty (excl. sample)',
  stockQtyExcludeSample: 'Stock qty (excl. sample)',
  stockQtySample: 'Stock qty (sample)',
  activateTimeLabel: 'Activation time',
  agentAreaLabel: 'Agent area',
  belongProvinceCity: 'Province/City',
  agentOrderingAgentId: 'Agent ID',
  agentOrderingAgentName: 'Agent name',
  hardwareActiveCnt: 'Hardware activation (non-sample)',
  hardwareMachineCnt: 'Hardware activation (sample)',
  hardwareChildMachineCnt: 'Hardware activation (child)',
  softwareActiveCnt: 'Software activation (non-sample)',
  softModelMachineCnt: 'Software activation (sample)',
  softChildMachineCnt: 'Software activation (child)',
  modelNameCol: 'Product type',
  orderTimeLabel: 'Order time',
  orderingTip: 'Order qty = confirmed regional transfer orders + HQ paid orders.',
  buyNumCol: 'Order qty',
  dispatchDateLabel: 'Dispatch date',
  agentVersionNewTip: 'Query all agents in the region: purchase, activation and stock in the selected period.',
  // 潜在客户 PotentialCustomers
  belongArea: 'Area',
  potentialCustomers: 'Potential customers',
  addPotentialCustomers: 'New potential',
  invitations: 'Invitations',
  activeMachineC: 'Machine C activation',
  // 激活簇 ActivationCluster
  placeholderCampusId: 'Enter dealer ID',
  areaName: 'Region',
  lifeCycleLabel: 'Life cycle',
  placeholderAll: 'All',
  lifeCycleCol: 'Life cycle',
  joinTime: 'Join time',
  newbieProgress: 'Newbie progress',
  performanceProgress: 'Performance progress',
  exportCurrentDetail: 'Export current',

  // No-province-agent renewal activation quantity assessment
  renewalActivationAgentId: 'Agent ID',
  renewalActivationAreaName: 'District/City',

  // 代理商订货数据 AgentOrdering
  placeholderSelectPeriod: 'Select period',
  dispatchTimeLabel: 'Dispatch time',
  campusSubStatDetailAgentId: 'Agent ID',
  campusSubStatDetailAgentName: 'Agent name',
  agentServiceId: 'Agent service ID',
  agentServiceName: 'Agent service name',
  consumeNum: 'Consume months',
  missSubReturnNum: 'Miss sub return months',
  basicNum: 'Return base',
  // 仓库库存 Inventory
  campusAllInventory: 'Campus total stock',
  warehouseInventory: 'Warehouse stock',
  storeInventory: 'Store stock',
  // 跨区域活跃设备 CrossRegActiveEquipment
  reportTimeLabel: 'Report time',
  crossRegionReportAgentId: 'Agent ID',
  crossRegionReportAgentName: 'Agent name',
  crossTypeName: 'Cross-region type',
  reportNum: 'Report qty',
  reportActiveNum: 'Report active qty',
  reviewNum: 'Review qty',
  reviewNoComplianceNum: 'Review non-compliance qty',
  // 代理商进销存 AgentVersion  
  regionAgentLabel: 'Region agent',
  cashBackAgentId: 'Agent ID',
  cashBackAgentName: 'Agent name',
  orderNoColon: 'Order no.: ',
  placeholderOrderNo: 'Enter order no.',
  orderNoLabelShort: 'Order no.',
  placeholderOrderNoShort: 'Enter order no.',
  orderNo: 'Order no.',
  cashBackBuyNum: 'Order qty',
  cashBackOrderAmount: 'Order amount',
  orderAmount: 'Order amount',
  cashTotal: 'Cash total',
  goldAccount: 'Gold account',
  cashPay: 'Cash pay',
  cashReward: 'Cash reward',
  paymentRefundPay: 'Payment refund',
  deliveryVoucherAmount: 'Delivery voucher amount',
  fissionDeduction: 'Fission deduction',
  productionStatus: 'Production status',
  transferQty: 'Transfer qty',
  dispatchRegionId: 'Dispatch region ID',
  dispatchRegionName: 'Dispatch region name',
  returnAgentId: 'Return agent ID',
  returnAgentName: 'Return agent name',
  deliveryTimeCol: 'Delivery time',
  rechargeAmount: 'Recharge amount',
  rechargeTimeCol: 'Recharge time',
  rechargeIdCol: 'Recharge ID',
  accountTypeCol: 'Account type',
  payMethod: 'Pay method',
  flowStatus: 'Flow status',
  confirmBy: 'Confirm by',
  confirmTimeCol: 'Confirm time',
  confirmRemark: 'Confirm remark',
  payStatus: 'Pay status',
  orderStatus: 'Order status',
  receiveBuyNum: 'Dispatch qty',
  productPrice: 'Product price',
  dispatchTimeStr: 'Order dispatch time',
  dispatchType: 'Dispatch type',
  dispatchCampusId: 'Dispatch campus ID',
  dispatchCampusName: 'Dispatch campus name',
  regionCampusId: 'Region campus ID',
  regionCampusName: 'Region campus name',
  totalProductSubFee: 'Sub fee cash amount',
  shareholdingRatio: 'Shareholding ratio (%)',
  partnerRewardRatio: 'Partner reward ratio (%)',
  subscriptionFee: 'Subscription fee rebate',
  addedFee: 'Added fee',
  // 代理商进销存 AgentVersion  
  profitTimeLabel: 'Profit start time',
  cashPaymentAgentId: 'Agent ID',
  cashPaymentAgentName: 'Agent name',
  campusName: 'Agent name',
  agentTypeName: 'Agent type',
  periodStartDate: 'Period start',
  periodEndDate: 'Period end',
  regionPayAmount: 'Region cash pay amount',
  regionWithdrawalAmount: 'Region withdrawal amount',
  regionSurplusAmount: 'Region surplus amount',
  // 代理商活跃度 HighActivity
  highActivityTip: 'From Apr 2024, dealer assessment policy updated. This report is for tracking sub-dealer activity only; monthly ranking is no longer updated from Apr 2024. For assessment data, see',
  highActivityLink: '"Sub-dealer & entity assessment data"',
  agentId: 'Dealer ID',
  agentName: 'Dealer name',
  monthCol: 'Month',
  rank: 'Rank',
  conutryRate: 'Monthly national avg activity rate',
  totalRate: 'Monthly activity rate',
  weekBegin: 'Week',
  weektotalRate: 'Weekly activity rate',
  weekRealRatio: 'Weekly rate (actual)',
  weekRatio: 'Weekly rate',
  weekHealthRate: 'Weekly health rate',
  activeCount: 'Weekly 5-star count',
  weekHealthCount: 'Weekly health count',
  activeTotalCount: 'Weekly active count',
  // 激活簇 ActivationCluster
  placeholderSoftwareActiveTime: 'Select software activation time',
  addressFull: 'Province/City',
  hardwareMachineCnt: 'Hardware activation (sample)',
  hardwareChildMachineCnt: 'Hardware activation (child)',
  softModelMachineCnt: 'Software activation (sample)',
  softChildMachineCnt: 'Software activation (child)',
  // 激活簇 ActivationCluster
  isMunicipalityName: 'Municipality district',
  lastYearActivation: 'Last year activation',
  incrementValue: 'Increment target',
  periodActivation: 'Period activation',
  targetGap: 'Target gap',
  // 代理商订货数据 AgentOrdering
  cashBackOrderStatus: 'Order status',
  receiveNum: 'Dispatched qty',
  dispatchTypeName: 'Dispatch type',
  cashBackRegionCampusId: 'Dispatch region campus ID',
  cashBackRegionCampusName: 'Dispatch region campus name',
  receivedAmount: 'Received amount',
  dlAmount: 'Cash pay amount',
  lbAmount: 'Fission pay amount',
  orderCreateTimeStr: 'Order time',
  completionTimeStr: 'Completion time',
  receiveConfirmTimeStr: 'Receive confirm time',
  totalReturnAmount: 'Total return amount',
  dlReturnAmount: 'Cash return amount',
  lbReturnAmount: 'Fission return amount',
  returnTimeCol: 'Return time',
  // 代理商进销存 AgentVersion  
  dealerLabel: 'Dealer',
  timeLabel: 'Time',
  yearMonth: 'Year-Month',
  protectionCnt: 'Quota',
  exportBtn: 'Export',
  // 代理商进销存 AgentVersion  
  regionAgentLabelLong: 'Regional partners',
  changeTimeLabel: 'Change time',
  purchaseAgentId: 'Purchase agent ID',
  purchaseAgentName: 'Purchase agent name',
  purchaseOrderNo: 'Purchase order no.',
  oldDispatchCampusId: 'Prev dispatch agent ID',
  oldDispatchCampusName: 'Prev dispatch agent name',
  newDispatchCampusId: 'Curr dispatch agent ID',
  newDispatchCampusName: 'Curr dispatch agent name',
  changeTimeCol: 'Change time',
  opUserName: 'Operator',
  // 代理商进销存 AgentVersion    
  mainName: 'Entity',
  assessQuarter: 'Assess quarter',
  quarterRank: 'Quarter rank',
  assessStatus: 'Assess status',
  avgRateQuarter: 'Quarter national avg activity rate',
  avgRateActualQuarter: 'Quarter national avg rate (actual)',
  totalRateQuarter: 'Quarter activity rate',
  totalRateActualQuarter: 'Quarter rate (actual)',
  lastTotalRateActual: 'Last quarter rate (actual)',
  monthName: 'Month',
  isRecord: 'Month in assess',
  monthTotalActiveRate: 'Month activity rate',
  monthActiveRate: 'Month active rate',
  monthActiveTrueRate: 'Month rate (actual)',
  monthHealthRateCol: 'Month health rate',
  highActiveCountCol: 'Month weekly 5-star count',
  monthHealthCountCol: 'Month weekly health count',
  monthActiveCountCol: 'Month weekly active count',
  // 合作伙伴 material CustomerOrderDetails
  // Partner material CustomerOrderDetails
  materialNameLabel: 'Material name',
  placeholderMaterialName: 'Enter material name',
  materialNameCol: 'Material name',
  catalogNameCol: 'Category',
  materialPreviewCol: 'Preview',
  updateTimeCol: 'Last edit time',
  updateByNameCol: 'Last editor',
  createMaterialBtn: 'Create material',
  statusPendingPublish: 'Pending publish',
  statusPublished: 'Published',
  publishShort: 'Publish',
  cancelPublishShort: 'Unpublish',
  thisAddressActiveSnCol: 'SN codes activated at this address',
  yearMonthCol: 'Month',
  softActiveCountCol: 'Soft activate count',
  studentNumCol: 'Student count',
  ddjRankCol: 'National active rank',
  totalRatioCol: 'Monthly total ratio',
  activeRatioCol: 'Monthly active ratio',
  healthRatioCol: 'Monthly health ratio',
  activeCountCol: 'Weekly avg active',
  // 星级代理商操作 StarAgentOperation
  // StarAgentOperation
  areaQueryLabel: 'Area:',
  placeholderArea: 'Select agent area',
  starFilterLabel: 'Star level:',
  placeholderStar: 'Select star level',
  quarterFilterLabel: 'Quarter:',
  collapse: 'Collapse',
  expand: 'Expand',
  clearFilterTip: 'Clear filter',
  dealerQueryLabel: 'Dealer:',
  placeholderDealerIdOrName: 'Enter dealer ID or name',
  sortRuleLabel: 'Sort:',
  placeholderSortRule: 'Select sort rule',
  queryBtn: 'Query',
  historyActivateNumCol: 'History activated',
  unitTai: '',
  monthWeekActiveNumCol: 'Monthly weekly avg active',
  unitPerson: '',
  currentStarLevelCol: 'Current star',
  over5Star: 'Over 5-star',
  starSuffix: ' star',
  currentGrowthValueCol: 'Current growth',
  nationalRankCol: 'National rank',
  relegationNeedGrowthCol: 'Growth to retain',
  upgradeNeedGrowthCol: 'Growth to upgrade',
  reachedUpgrade: 'Eligible',
  estimatedNextStarCol: 'Est. next star',
  adjustStarBtn: 'Adjust star',
  adjustGrowthBtn: 'Adjust growth',
  viewGrowthDetailBtn: 'View growth detail',
  currentStarLabel: 'Current star:',
  adjustStarLabel: 'Adjust star:',
  increaseStar: 'Increase',
  decreaseStar: 'Decrease',
  starQtyLabel: 'Star qty:',
  increase: 'Increase',
  decrease: 'Decrease',
  oneStarLevel: '1 star',
  starAdjustTip: 'Only 1 star per operation',
  adjustReasonLabel: 'Reason:',
  placeholderReasonMin10: 'At least 10 characters',
  currentGrowthLabel: 'Current growth:',
  adjustGrowthLabel: 'Adjust growth:',
  increaseGrowth: 'Increase',
  decreaseGrowth: 'Decrease',
  growthValueLabel: 'Growth:',
  placeholderEnterNumber: 'Enter number',
  operationRecordCol: 'Record',
  afterStarLevelCol: 'Star after',
  reasonCol: 'Reason',
  view: 'View',
  operationTimeCol: 'Time',
  operatorCol: 'Operator',
  operationReasonTitle: 'Reason',
  close: 'Close',
  growthProcessCol: 'Process',
  growthValueCol: 'Growth',
  finishTimeCol: 'Finish time',
  gotIt: 'Got it',
  adjustStar: 'Adjust Star',
  adjustGrowth: 'Adjust Growth',
  growthValueDetail: 'Growth Detail',
  sortAll: 'All',
  sortGrowthAsc: 'Growth asc',
  sortGrowthDesc: 'Growth desc',
  sortStarAsc: 'Star asc',
  sortStarDesc: 'Star desc',
  ruleReasonRequired: 'Enter reason',
  ruleReasonLength: 'Reason 10-200 chars',
  ruleGrowthValueRequired: 'Enter growth value',
  ruleSelectStar: 'Select star change',
}
